import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

/**
 * Class Management v2's "Remove Time Slot" confirmation. Same inputs/outputs
 * and behaviour as TimetableTimeClashComponent (so the inherited logic that
 * drives it is unchanged); only the markup/look is the fees-v2 modal.
 * Styling comes from the shared fv2-modal-* rules plus classmanage-v2's CSS.
 */
@Component({
  selector: 'app-timetable-time-clash-v2',
  templateUrl: './timetable-time-clash-v2.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class TimetableTimeClashV2Component {
  @Input() fullMessageHTMLString: string;
  @Input() showTimeSlot: string;
  @Input() showClass: string;
  @Input() staffImage: string;
  @Input() visible: string;
  @Output() save_button_event: EventEmitter<any> = new EventEmitter();
  @Output() closePopup: EventEmitter<any> = new EventEmitter();

  removeTimeSlot(): void {
    this.visible = 'none';
    this.save_button_event.emit();
  }

  cancel(): void {
    this.visible = 'none';
    this.closePopup.emit();
  }
}
